<template>
	<v-autocomplete
		:error="errorBorder"
		:error-messages="$props.error"
		:items="options"
		:label="label"
		:readonly="readonly"
		:clearable="clearable && !readonly"
		:disabled="disabled"
		:hide-details="hideDetails"
		:no-data-text="$t('labels.noData')"
		item-text="label"
		item-value="value"
		v-model="selectedValue"
	>
		<template #prepend-item>
			<slot name="firstItem"></slot>
		</template>
		<template #prepend>
			<slot name="prepend"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'Dropdown',
	props: {
		readonly: Boolean,
		disabled: Boolean,
		clearable: Boolean,
		value: [String, Number, Boolean, Object],
		ajax: Boolean,
		data: [Array, String],
		label: String,
		apiCallOnSelect: Boolean,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	emits: ['get-item'],
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false,
			protected: null,
			latestValue: null,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != this.selectedValue) {
					this.protected = newVal;
					this.setValue(newVal);
				}
			}
		},
		selectedValue: function (val) {
			if (val != this.$props.value) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						});
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					});
				}
				this.$nextTick(() => {
					this.callChange();
				});
			}
			if (this.apiCallOnSelect) {
				var vm = this;
				let endpoint = this.data;
				const parts = this.data.split('/');
				endpoint = parts[0];
				this.$APICall(
					'get',
					endpoint + '/' + this.selectedValue,
					{},
					(data, success) => {
						if (success) {
							vm.$emit('get-item', data);
						}
					},
					false
				);
			}
		},
		data: function (val) {
			if (val !== null) {
				this.fetchData();
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		fetchData() {
			var vm = this;
			this.$APICall(
				'get',
				'select/' + this.data,
				{},
				(data, success) => {
					if (success) {
						vm.options = data;
						vm.ajaxLoaded = true;
					}
				},
				false
			);
		},
		setValue(newVal) {
			this.latestValue = newVal;
			if (this.$props.ajax) {
				var vm = this;
				this.$APICall(
					'get',
					'select/' + this.endpoint,
					{ protected: this.protected },
					(data, success) => {
						if (success && vm.latestValue == newVal) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}
					},
					false
				);
			} else {
				this.options = this.$props.data;
				this.selectedValue = newVal;
			}
		},
	},
	mounted() {
		if (this.$props.ajax) {
			this.endpoint = this.$props.data;
		}

		this.protected = this.$props.value;
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped>
.v-select-list {
	max-width: 1100px;
}
</style>
